// extracted by mini-css-extract-plugin
module.exports = {"sort":"VP","sortSelect":"WP","disabled":"XP"};